import { Inject, Injectable } from "@angular/core";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { Port } from "../../../../links.model";
import { LinkService } from "../../../../services/link.service";

/**
 * Serviço responsável por tratar a exibição de Portas membros
 * de Port-Channels e Link Aggregations na modal de links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkDevicePortChannelMembersService {

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly translate: any, private readonly linkService: LinkService,
            private readonly nmsDialogService: NmsDialogService) {
        // Construtor intencionalmente vazio
    }

    getPortMembers(endDevice: Device, endPort: Port) {
        this.linkService.getPortMembers(endDevice.id, endPort.portNo).subscribe((portsMembers: string[]) => {
            const message = portsMembers.length > 0
                ? portsMembers.join("<br />")
                : `<i>${this.translate.instant("links.modal.see.ports.members.empty")}</i>`;
            const title = this.translate.instant("links.modal.see.ports.members.from");

            this.nmsDialogService.openDialog({
                description: message, title: `${title} ${endPort.portName}`, isConfirm: false, bindHtml: true
            });
        });
    }

    getPortMembersLinkTooltip(endPort: Port) {
        const suffix = this.translate.instant("links.modal.see.ports.members.part.of");

        return `${suffix} ${endPort.portName}`;
    }
}
